import { render, staticRenderFns } from "./edit-threshold.vue?vue&type=template&id=503d092c&"
import script from "./edit-threshold.vue?vue&type=script&lang=ts&"
export * from "./edit-threshold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports